<router-outlet></router-outlet>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-spin-fade" fullScreen="true">
  <h5 class="text-white">{{ spinner.message }}</h5>
</ngx-spinner>
